
import { isLocalHost } from 'helper/localhost'

// Allows override of API Url. Set to false to use the default
export const APIUrl = isLocalHost 
  ? 'https://sudwestfryslan.evmaps.nl/.netlify/identity' // local needs override to work
  : false


// Allows override of functions url root.
export const FunctionUrl = isLocalHost
  ? 'https://sudwestfryslan.evmaps.nl'
  : ''


// Whether login is required
export const isActive = true

// The user pool (multi-tenancy)
// Note: users only show up in Netlify Dashboard if audience is empty
export const audience = '' // tco-rotterdam